import { React, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import NewBookingPopup from '../components/NewBookingPopup';
import AppShell from '../components/app/AppShell';
import { isAppBuild } from '../utils/platform';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Layout = ({ children, hideHeader, hasPermission }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!hasPermission) {
            toast.error("You don't have permission to access this!");
            navigate(-1);
        }
    }, [navigate]);

    useEffect(() => {
        document.title = 'Boost Zone — Admin';
        let tag = document.querySelector('meta[name="description"]');
        if (!tag) {
            tag = document.createElement('meta');
            tag.name = 'description';
            document.head.appendChild(tag);
        }
        tag.content = 'Manage users, bookings, rooms, services and memberships.';
    }, []);

    return (
        <div className="d-flex flex-column flex-root app-root" id='kt_app_root'>
            <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
                {/* App build: bottom tabs instead of the sidebar. */}
                {!hideHeader && isAppBuild && (
                    <AppShell>
                        {children}
                        <NewBookingPopup />
                    </AppShell>
                )}
                {!hideHeader && !isAppBuild && (
                    <div>
                        <Header />
                        <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                            <Sidebar />
                            {children}
                        </div>
                        {/* Live new-booking alert, active on every admin screen */}
                        <NewBookingPopup />
                    </div>
                )}
                {hideHeader && (
                    <main>
                        {children}
                    </main>
                )}
            </div>
        </div>
    );
};

export default Layout;
